<template>
  <div class="set-forever-goods">
    <div class="page_title flex_between">
      <span>终身分佣奖</span>
      <el-button type="primary" style="width: 92px" @click="back" size="medium"
        >返回</el-button
      >
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container" style="padding: 10px 20px 20px 20px">
        <div class="search-box">
          <!-- 商品名称 -->
          <div class="item">
            <span style="width: 70px">商品名称</span>
            <div class="item-content">
              <el-input
                v-model="setForeverGoodsForm.goods_name"
                size="small"
                clearable
                @keyup.enter.native="seachEnterFun"
                placeholder="请输入"
              ></el-input>
            </div>
            <el-button
              type="primary"
              size="small"
              style="margin-left: 20px"
              @click="getList"
              >查询</el-button
            >
          </div>
          <el-button
            type="primary"
            size="small"
            style="margin-left: 20px"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('1793') : false
            "
            @click="addGoods"
            >添加商品</el-button
          >
        </div>

        <div style="border: solid 1px #c9cbd6">
          <el-table
            v-loading="tableLoading"
            :data="setForeverGoodsData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              v-for="item in tableHeader"
              :key="item.prop"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              :fixed="item.fixed"
            >
              <template slot-scope="scope">
                <div v-if="item.prop == 'goods_info'" class="align-center">
                  <img
                    :src="scope.row.picture_str"
                    style="width: 100px; height: 100px"
                  />
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="scope.row.goods_name"
                    placement="top-start"
                  >
                    <div class="text-ellipsis" style="margin-left: 10px">
                      {{ scope.row.goods_name }}
                    </div>
                  </el-tooltip>
                </div>

                <div v-else>
                  {{
                    JSON.stringify(scope.row[item.prop]) === "null"
                      ? ""
                      : scope.row[item.prop]
                  }}
                </div>
              </template>
            </el-table-column>

            <el-table-column
              label="操作"
              width="120"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="medium"
                  @click="delBtn(scope.row.forever_goods_id)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1795')
                      : false
                  "
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <pagination
          v-show="totalNum > 0"
          :total="totalNum"
          :page.sync="pagination.page"
          :limit.sync="pagination.pageNumber"
          @pagination="getList"
        />
      </div>
    </div>
    <!-- 添加商品 -->
    <el-dialog title="选择商品" :visible.sync="selectGoodsDia">
      <div style="padding: 10px">
        <div class="search-box">
          <!-- 商品名称 -->
          <div class="item">
            <span style="width: 70px">商品名称</span>
            <div class="item-content">
              <el-input
                v-model="selectGoodsForm.goods_name"
                size="small"
                clearable
                @keyup.enter.native="seachGoodsEnterFun"
                placeholder="请输入"
              ></el-input>
            </div>
            <el-button
              type="primary"
              size="small"
              style="margin-left: 20px"
              @click="getGoodsList"
              >查询</el-button
            >
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            v-loading="tableLoading"
            :data="selectGoodsData"
            tooltip-effect="dark"
            style="width: 100%"
            height="400px"
            :header-cell-style="{ background: '#F5F5F5' }"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column
              v-for="item in tableHeader"
              :key="item.prop"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              :fixed="item.fixed"
            >
              <template slot-scope="scope">
                <div v-if="item.prop == 'goods_info'" class="align-center">
                  <img
                    :src="scope.row.picture_str"
                    style="width: 100px; height: 100px"
                  />
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="scope.row.goods_name"
                    placement="top-start"
                  >
                    <div class="text-ellipsis" style="margin-left: 10px">
                      {{ scope.row.goods_name }}
                    </div>
                  </el-tooltip>
                </div>

                <div v-else>
                  {{
                    JSON.stringify(scope.row[item.prop]) === "null"
                      ? ""
                      : scope.row[item.prop]
                  }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <pagination
          v-show="selectGoodsTotalNum > 0"
          :total="selectGoodsTotalNum"
          :page.sync="selectGoodsPagination.page"
          :limit.sync="selectGoodsPagination.pageNumber"
          @pagination="getGoodsList"
        />
        <div slot="footer" class="dialog-footer" style="text-align: right">
          <el-button @click="selectGoodsDia = false">取 消</el-button>
          <el-button
            type="primary"
            @click="comfirmGoods"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('1794') : false
            "
            >确 定</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from "dayjs";
import doctor_fee from "@/api/doctor_fee.js";
import Pagination from "@/components/Pagination/index";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      setForeverGoodsForm: {
        goods_name: "",
      },
      tableHeader: [
        {
          label: "商品",
          prop: "goods_info",
          width: "auto",
          align: "center",
          fixed: "left",
        },
        {
          label: "库存",
          prop: "stock",
          width: "200",
          align: "center",
          fixed: false,
        },
        {
          label: "价格",
          prop: "price",
          width: "200",
          align: "center",
          fixed: false,
        },
      ],
      setForeverGoodsData: [],
      selectGoodsForm: {
        goods_name: "",
      },
      selectGoodsTableLoading: false,
      selectGoodsDia: false,
      selectGoodsData: [],
      selectGoodsTotalNum: 0,
      selectGoodsPagination: {
        page: 1,
        pageNumber: 10,
      },
      multipleSelection: [],
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm:ss");
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let params = Object.assign({}, this.pagination, this.setForeverGoodsForm);
      this.tableLoading = true;
      doctor_fee.getForeverGoodsList(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.setForeverGoodsData = data.list;
          this.totalNum = data.total;
          this.tableLoading = false;
        }
      });
    },
    seachEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getList();
      }
    },

    // 删除
    delBtn(forever_goods_id) {
      this.$confirm("确认删除该商品吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          doctor_fee.deleteForeverGoods({ forever_goods_id }).then((res) => {
            let { code } = res;
            if (code === 0) {
              this.$message.success("删除成功");
              this.getList();
            }
          });
        })
        .catch(() => {});
    },
    // 添加
    addGoods() {
      this.selectGoodsForm.goods_name = "";
      this.selectGoodsPagination.page = 1;
      this.multipleSelection = [];
      this.selectGoodsDia = true;
      this.getGoodsList();
    },
    seachGoodsEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getGoodsList();
      }
    },
    // 获取选择商品列表
    getGoodsList() {
      let params = Object.assign(
        {},
        this.selectGoodsPagination,
        this.selectGoodsForm
      );
      this.selectGoodsTableLoading = true;
      doctor_fee.getGoodsList(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.selectGoodsData = data.list;
          this.selectGoodsTotalNum = data.total;
          this.selectGoodsTableLoading = false;
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 确认添加
    comfirmGoods() {
      if (!this.multipleSelection.length) {
        this.$message.warning("请选择商品");
        return;
      }
      let goods_ids = this.multipleSelection.map((item) => item.goods_id);
      doctor_fee
        .saveForeverGoods({ goods_ids: goods_ids.join(",") })
        .then((res) => {
          let { code } = res;
          if (code === 0) {
            this.$message.success("添加成功");
            this.selectGoodsDia = false;
            this.getList();
          }
        });
    },
    back() {
      history.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.set-forever-goods {
  .search-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      span {
        display: inline-block;
        width: 80px;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
    .item-content {
      // width: 100%;
      .el-date-editor {
        width: 100%;
      }
    }
  }
}
</style>
